import { call } from 'redux-saga/effects';
import { t } from '../../app/i18n';

const required = { required: true, message: t('Povinný údaj') };

const radioAgreement = [
  required,
  {
    validator: (rule, value, callback) =>
      callback(!value ? t('Musíte súhlasiť s podmienkami') : undefined),
  },
];

const email = { type: 'email', message: t('E-mail nie je správny') };

const number = {
  validator: (rule, value, callback) =>
    callback(value && isNaN(parseInt(value, 10)) ? t('Hodnota musí byť číslo') : undefined),
};

const positiveNumber = {
  validator: (rule, value, callback) =>
    callback(value && value <= 0 ? t('Hodnota musí byť väčšia ako 0') : undefined),
};

const amountLessThanBalance = accountBalance => ({
  validator: (rule, value, callback) => {
    // callback(parseInt(value, 10) > accountBalance ? t('Nedostatok prostriedkov') : undefined);
    const cleanedValue = value.replace(/\s/g, '').replace(',', '.');
    const numericValue = parseFloat(cleanedValue);
    callback(numericValue > accountBalance ? t('Nedostatok prostriedkov') : undefined);
  },
});

const divisibleBy = number => ({
  validator: (rule, value, callback) =>
    callback(value && value % number !== 0 ? t(`Hodnota musí byť násobok ${number}`) : undefined),
});

const noMoreThanTwoDecimalPlaces = {
  validator: (rule, value, callback) => 
    callback(value && !/^\d*(\.\d{0,2})?$/.test(value.replace(',','.')) ? t(`Hodnota môže mať najviac dve desatinné miesta`) : undefined)
}

const currencyChecker = {
  validator: (rule, value, callback) => 
    callback(value && !/^\d*([\.,]\d{0,2})?$/.test(value) ? t(`Povolené iba čísla. Hodnota môže mať najviac dve desatinné miesta`) : undefined)
}

const withdrawalAmount = accountBalance => [
  required,
  number,
  positiveNumber,
  noMoreThanTwoDecimalPlaces,
  amountLessThanBalance(accountBalance),
];

const requiredTrue = {
  validator: (rule, value, callback) => {
    callback(!value ? t('Povinný údaj') : undefined);
  }
};

const maxLength = length => ({
  validator: (rule, value, callback) =>
    callback(value && !(value.length <= length) ? t(`Maximálny počet znakov je ${length}`) : undefined),
})

const specificLength = length => ({
  validator: (rule, value, callback) =>
    callback(value && !(value.length === length) ? t(`Nesprávny počet znakov`) : undefined),
});

const numbersOnly = {
  validator: (rule, value, callback) => {
    callback(value && !(/^[0-9]+$/.test(value)) ? t('Povolené iba čísla') : undefined);
  }
};

const numbersOrCharactersOnly = {
  validator: (rule, value, callback) => {
    callback(value && !(/^[a-zA-Z0-9]+$/.test(value)) ? t('Povolené iba čísla a písmená') : undefined);
  }
};

const moreThanValue = minValue => ({
  validator: (rule, value, callback) =>
    callback(value && value <= minValue ? t(`Hodnota musí byť väčšia ako ${minValue}`) : undefined),
});

const lessThanValue = maxValue => ({
  validator: (rule, value, callback) =>{
    const number = Number(maxValue)
    callback(value && Number(value) > number ? t(`Hodnota musí byť menšia ako ${maxValue.toFixed(2)}`) : undefined)
  } 
});

const characterLimitOnName = {
  validator: (rule, value, callback) => {
    callback(value && (value.length > 30) ? t(`Meno nesmie mať viac ako 30 znakov`): undefined)
  }
}

const characterLimitOnQuestion = {
  validator: (rule, value, callback) => {
    callback(value && (value.length > 1000) ? t(`Otázka nesmie byť dlhšia ako 1000 znakov`): undefined)
  }
}

export default {
  required: [required],
  emailRequired: [required, email],
  email,
  currencyChecker,
  withdrawalAmount,
  number,
  positiveNumber,
  amountLessThanBalance,
  divisibleBy,
  radioAgreement,
  requiredTrue,
  maxLength,
  specificLength,
  numbersOnly,
  numbersOrCharactersOnly,
  moreThanValue,
  lessThanValue,
  characterLimitOnName: [required, characterLimitOnName],
  characterLimitOnQuestion: [required, characterLimitOnQuestion]
};



// WEBPACK FOOTER //
// ./src/common/rules/rules.js